// this file added by Bearer Web Developer
export const validateEarliestDate = (value: string) => {
    if (value.length === 0) return "Earliest date is required";
}
export const validateEarliestTime = (value: string) => {
    if (value.length === 0) return "Earliest time is required";
}

